// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
	window.SITE = {};
  }

  SITE.sectionsMenuDropDown = function() {
	var subMenu = document.querySelector('#nav-sections .menu-container');
	subMenu.addEventListener("mouseenter",function() {
	  if (this.classList.contains('open')) {
		this.classList.remove('open')
	  }
	  else {
		this.classList.add('open')
	  }
	})

	subMenu.addEventListener("mouseleave",function() {
	  if (this.classList.contains('open')) {
		this.classList.remove('open')
	  }
	})

	subMenu.addEventListener("click",function() {
	  if (this.classList.contains('open')) {
		this.classList.remove('open')
	  }
	  else {
		this.classList.add('open')
	  }
	})


  }


  SITE.mobileHomePageSections = function() {
	var sections = document.querySelectorAll('article#page-377.page .page__sections div.section');
	for (var i = 0; i< sections.length; i++) {
	  var element = sections[i];
	  element.addEventListener("click", function() {
		var ctaLink = this.querySelector('a.button');
		console.log(ctaLink)

		if (window.innerWidth <= 767 ) {
		  window.location.href = ctaLink;
		}
	  })
	}
  }
})();


// Invocations
$(function () {
  SITE.sectionsMenuDropDown();
  SITE.mobileHomePageSections();
});
